import { createTrackingService, } from '@volkswagen-onehub/oneaudi-os-onesight';
/**
 * Adapter to map `TrackingServiceV2` (TFS) calls against the `TrackingServiceV3`
 * (onesight) api.
 */
export class TrackingAdapter {
    name;
    featureAppId;
    delegate;
    logger;
    constructor(appId, dataLayerV2, urlSanitizer, logger) {
        this.featureAppId = appId;
        this.logger = logger ?? console;
        this.logger.debug(`${this.logPrefix()} Initialised`);
        const dataLayerV3 = this.mapDataLayer(dataLayerV2);
        this.delegate = createTrackingService(appId, dataLayerV3, urlSanitizer, logger);
    }
    get featureAppName() {
        this.logger.debug(`${this.logPrefix()} Getting feature app name`);
        return this.name;
    }
    set featureAppName(featureAppName) {
        const oldName = this.name;
        this.name = featureAppName;
        this.logger.debug(`${this.logPrefix()} Updating feature app name from '${oldName ?? 'undefined'}' to '${featureAppName ?? 'undefined'}'`);
        this.delegate.featureAppName = featureAppName;
    }
    track(event) {
        this.logger.info(`${this.logPrefix()} Delegating event`, event);
        this.delegateUpdates(event);
        this.delegate.track(event.event);
    }
    trackInternalNavigation(event) {
        this.logger.info(`${this.logPrefix()} Delegating internal navigation event`, event);
        this.delegateUpdates(event);
        this.delegate.trackInternalNavigation(event.event, event.targetHref);
    }
    registerImpressionTracking(element, dataCallback) {
        this.logger.info(`${this.logPrefix()} Delegating impression tracking on element '${element?.tagName}'`);
        const callback = () => dataCallback().event;
        return this.delegate.registerImpressionTracking(element, callback);
    }
    updateComponent(componentUpdate) {
        this.logger.info(`${this.logPrefix()} Delegating component update`, componentUpdate);
        this.delegate.updateComponent(componentUpdate);
    }
    updateUser(userUpdate) {
        this.logger.info(`${this.logPrefix()} Delegating user update`, userUpdate);
        this.delegate.updateUser(userUpdate);
    }
    evaluateLinkType(targetUrl) {
        this.logger.debug(`${this.logPrefix()} Delegating link type evaluation of '${targetUrl}'`);
        return this.delegate.evaluateLinkType(targetUrl);
    }
    getDatalayer() {
        this.logger.debug(`${this.logPrefix()} Delegating data layer get. Please don't use the datalayer directly!`);
        return this.delegate.getDatalayer();
    }
    sanitizeUrl(url) {
        this.logger.debug(`${this.logPrefix()} Delegating url sanitation of '${url}'`);
        return this.delegate.sanitizeUrl(url);
    }
    unbind() {
        this.logger.debug(`${this.logPrefix()} Delegating unbind`);
        this.delegate.unbind();
    }
    logPrefix() {
        return `[TrackingAdapter(id='${this.featureAppId}' / name='${this.name ?? 'undefined'}')]`;
    }
    mapDataLayer(datalayer) {
        if (!datalayer) {
            return undefined;
        }
        // fix user typing mismatch
        if (datalayer.user && !Array.isArray(datalayer.user)) {
            this.logger.debug(`${this.logPrefix()} Migrating datalayer user object to array.`);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // eslint-disable-next-line no-param-reassign
            datalayer.user = [datalayer.user];
        }
        return datalayer;
    }
    delegateUpdates(event) {
        if (event.userUpdate) {
            this.delegate.updateUser(event.userUpdate);
        }
        if (event.componentUpdate) {
            this.delegate.updateComponent(event.componentUpdate);
        }
    }
}
